import React from "react";

class Auth extends React.Component {
    render() {
        const { children, routes, width } = this.props;

        return (
            <div>
                {children}
            </div>
        );
    }
}

export default Auth;